import React, { FC } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@store/store";
import PatientSelect from "@components/PatientSelect/PatientSelect";
import { selectPatientId } from "@store/homeSlice";

const HomePatientSelect: FC = () => {
  const dispatch = useDispatch();
  const patients = useSelector((state: RootState) => state.home.patients);
  const selectedPatientId = useSelector(
    (state: RootState) => state.home.selectedPatientId,
  );

  const onSelectPatient = (patientId: string | null) => {
    dispatch(selectPatientId(patientId));
  };

  return (
    <PatientSelect
      patients={patients}
      selectedPatientId={selectedPatientId}
      onChange={onSelectPatient}
    />
  );
};

export default HomePatientSelect;
